export const GET_DEFAULT_MODEL = "GET_DEFAULT_MODEL";
export const SET_DEFAULT_MODEL = "SET_DEFAULT_MODEL";
